export const NAME_INVALID_CHARACTERS = 'name_invalid_characters'

const INVISIBLE_CHARACTERS = 'name_has_invisible_characters'

const isNameError = subError => subError.message === INVISIBLE_CHARACTERS

const getSubErrors = error => error?.response?.data?.apierror?.subErrors || []

export const parseNameValidationErrors = (error) => {
	const apierror = error?.response?.data?.apierror
	if (apierror?.errorStatusCode !== NAME_INVALID_CHARACTERS) return null
	const nameSubErrors = getSubErrors(error).filter(isNameError)
	if (!nameSubErrors.length) return null
	return nameSubErrors.reduce((result, subError) => ({
		...result,
		[subError.field.replace(/\[(\d+)\]/g, '.$1')]: subError.message,
	}), {})
}

export const getForeignSubErrors = (error) => getSubErrors(error).filter(subError => !isNameError(subError))
